// Maps to devices associated with Screen Breakpoints
export enum DeviceTypes {
	Mobile = 'mobile',
	Tablet = 'tablet',
	Desktop = 'desktop',
}
